import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

/**
 * Serializes a planning's date range for the API.
 *
 * Shift/slot times are stored as "wall-clock-as-UTC" (a 14:00 shift is persisted as
 * 14:00Z). A planning therefore has to expose its start/end as UTC day boundaries in
 * the same frame, otherwise the arbitrary time-of-day carried by the picked Date leaks
 * into range comparisons and hides shifts near the edges (e.g. afternoon shifts on the
 * last day when the end instant lands around noon).
 *
 * `utc(true)` keeps the picked wall-clock date and reinterprets it as UTC, so the chosen
 * day is preserved regardless of the user's timezone (no offset-induced day shift).
 */
export function serializePlanningDateRange(start: Date, end: Date): { startDate: string; endDate: string } {
  return {
    startDate: dayjs(start).utc(true).startOf('day').toISOString(),
    endDate: dayjs(end).utc(true).endOf('day').toISOString(),
  }
}
